import { useMemo } from 'react';
import { MenuItem, TextField } from '@mui/material';

import { InputField } from '../fields/input';

import { OrganizationTextFieldProps } from './types';

export const OrganizationTextField = ({
  name,
  tenants,
  emptyLabel,
  label = 'Organization',
  placeholder = 'Organization',
  ...props
}: OrganizationTextFieldProps) => {
  const textFieldProps = {
    label,
    placeholder,
    select: true,
    fullWidth: true,
    ...props,
  };
  const items = useMemo(
    () => [
      ...(emptyLabel
        ? [
            <MenuItem key="" value="">
              {emptyLabel}
            </MenuItem>,
          ]
        : []),
      ...(tenants ?? []).map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      )),
    ],
    [tenants, emptyLabel]
  );

  if (name) {
    return (
      <InputField name={name} {...textFieldProps}>
        {items}
      </InputField>
    );
  }

  return <TextField {...textFieldProps}>{items}</TextField>;
};
